import React from "react";

interface IconCoursesProps {
  width?: string;
  height?: string;
  fill?: string;
}

const IconCourses: React.FC<IconCoursesProps> = ({
  width = "20px",
  height = "20px",
  fill = "#f7f5f5",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-layout-dashboard-icon lucide-layout-dashboard"
  >
    <path d="m16 6 4 14" />
    <path d="M12 6v14" />
    <path d="M8 8v12" />
    <path d="M4 4v16" />
  </svg>
);
export default IconCourses;
